import { InlineKeyboardButtonTypeUnion } from '@airgram/web';

export interface BotCommand {
  messageId: number;
  type: InlineKeyboardButtonTypeUnion;
}
